// Shared chrome for _auth+ routes: /login, /login-with-email, /signup (→
// redirect to /login), /forgot-password, /reset-password, /verify,
// /onboarding, /logout, /auth/xero, etc. Compact — wordmark left, "back
// to home" right, no marketing CTAs (redundant on auth pages), no footer
// (auth forms feel weird with a marketing footer beneath them).
//
// Precedent: books+/_layout.tsx and report+/_layout.tsx use the same
// _layout.tsx pattern. Wired via OWN_CHROME_PREFIXES in root.tsx.

import { Link, Outlet } from 'react-router'

export default function AuthLayout() {
	return (
		<div className="flex min-h-svh flex-col">
			<header className="border-border/60 border-b">
				<div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-6">
					<Link
						to="/"
						className="text-base font-semibold tracking-tight"
					>
						LedgerAI
					</Link>
					<Link
						to="/"
						className="text-muted-foreground hover:text-foreground text-sm"
					>
						← Back to home
					</Link>
				</div>
			</header>
			<Outlet />
		</div>
	)
}
